<template>
  <div>
    <h3 data-aos="fade-left">{{ $t('ac_cleaning.covered_service_section.title') }}</h3>
    <div data-aos="fade-right">
      <small v-html="$t('ac_cleaning.covered_service_section.subtitle')"></small>
    </div>
    <p class="py-2" >{{ $t('ac_cleaning.covered_service_section.text') }}</p>
    <div v-for="(detail, index) in details" :key="index" class="details">
      <img src="/static/img/acCleaning/svg/Check.svg">
      <!-- <p class="list" v-html="detail.detail"></p> -->
      <p class="list" v-html="$t(`ac_cleaning.covered_service_section.areas.${index}`)"></p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'บริการล้างแอร์ของ BeNeat ครอบคลุมอะไรบ้าง?',
      subtitle: `BeNeat ให้บริการล้างแอร์โดยทีมช่างผู้เชี่ยวชาญพร้อมมาตรฐานงานคุณภาพที่คุณวางใจได้เราดูแลทุกขั้นตอนอย่างละเอียด เพื่อให้แอร์ของคุณ <br/> สะอาด เย็นเร็ว ประหยัดพลังงาน และปลอดภัยต่อสุขภาพ`,
      description: 'รายการบริการที่รวมอยู่ในแพ็กเกจ',
      details: [
        {
          detail: 'ถอดล้างชิ้นส่วนหลักอย่างเป็นระบบ เช่น ฟิลเตอร์ แผงคอยล์ พัดลม ใบพัด และหน้ากากแอร์'
        },
        {
          detail: 'ทำความสะอาดท่อน้ำทิ้ง ป้องกันปัญหาน้ำหยดและกลิ่นไม่พึงประสงค์'
        },
        {
          detail: 'ล้างด้วยน้ำแรงดันสูงอย่างเหมาะสม เพื่อขจัดฝุ่น เชื้อรา และคราบสะสม'
        },
        {
          detail: 'ตรวจสอบระบบการทำงานก่อนและหลังล้าง เพื่อความมั่นใจในประสิทธิภาพของเครื่อง'
        },
        {
          detail: 'ทำความสะอาดพื้นที่หน้างานหลังให้บริการ'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../static/sass/page/ac_cleaning.scss';

.details {
  display: flex;
  gap: 8px;
  place-items: center;
  margin-bottom: 16px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/acCleaningRe/Covered.vue